import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Shelf.module.css';

/**
 * A grid of items that each have a picture of its own shape over a body of text. Items in a row
 * share two tracks: pictures stand on a common line (bottom-aligned, never stretched or cropped)
 * and the bodies beneath them line up, whatever mix of shapes the row holds.
 */
export const Shelf = ({
  children,
  className,
}: {
  readonly children: ReactNode;
  readonly className?: string | undefined;
}) => <div className={clsx(styles.shelf, className)}>{children}</div>;

export interface ShelfItemProps {
  /** The picture, usually a NaturalImage; it may be narrower than the column and is centred. */
  readonly visual: ReactNode;
  readonly children: ReactNode;
  readonly as?: 'article' | 'li' | 'div' | undefined;
  readonly className?: string | undefined;
  readonly bodyClassName?: string | undefined;
}

export const ShelfItem = ({
  visual,
  children,
  as: Element = 'article',
  className,
  bodyClassName,
}: ShelfItemProps) => (
  <Element className={clsx(styles.item, className)}>
    <div className={styles.visual}>{visual}</div>
    <div className={clsx(styles.body, bodyClassName)}>{children}</div>
  </Element>
);
